// extracted by mini-css-extract-plugin
module.exports = {"dividerSpacing":"VideoPromoWrapper_dividerSpacing__NCmo5"};